import { RootState } from "@/app/store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { authApi } from "./authApi";
import { AuthRequest, AuthResponse } from "./auth.interface";
import { APIResponse } from "@/types/custom-http";


// Iniciar Sesión de Usuario
export const login = createAsyncThunk<APIResponse<AuthResponse>, AuthRequest,
  {
    state: RootState;
    rejectValue: { status: number; message: string };
  }
>(
  'auth/login',
  async (crendentials, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        authApi.endpoints.login.initiate(crendentials)
      ).unwrap();
      return result;
    } catch (error: unknown) {
      // const messageToUser = handleErrorApi(error);
      // Verificamos si es un error conocido de la API
      // if (isApiError(error)) {
      //   return rejectWithValue({
      //     status: error.status,
      //     message: messageToUser|| 'Error al iniciar sesión',
      //   });
      // }
      console.error(' - Error al cerrar sesión:' + error);
      return rejectWithValue({
        status: 500,
        message: 'Error al iniciar sesión',
      });
    }
  }
);


// Cerrar Sesión de usuario
export const logout = createAsyncThunk<void, void,
  {
    state: RootState;
    rejectValue: { status: number; message: string };
  }
>(
  'auth/logout',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const result = await dispatch(
        authApi.endpoints.logout.initiate()
      ).unwrap();
      return result;
    } catch (error: unknown) {
      // const messageToUser = handleErrorApi(error);
      // Verificamos si es un error conocido de la API
      // if (isApiError(error)) {
      //   return rejectWithValue({
      //     status: error.status,
      //     message: messageToUser || 'Error al cerrar sesión',
      //   });
      // }
      console.error(' - Error al cerrar sesión:' + error);
      return rejectWithValue({
        status: 500,
        message: "Error al cerrar sesión",
      });
    }
  }
);
